import { Flame, Leaf, Clock, UtensilsCrossed } from "lucide-react";

const FEATURES = [
    {
        icon: Flame,
        title: "Wood-Smoked Mandi",
        desc: "Traditional Arabian technique — slow-smoked rice & meat over embers.",
    },
    {
        icon: UtensilsCrossed,
        title: "Sealed Dum Biryani",
        desc: "Hyderabadi heritage recipe, layered and sealed with dough.",
    },
    {
        icon: Leaf,
        title: "Fresh Spices Daily",
        desc: "Whole spices ground in-house every morning — zero shortcuts.",
    },
    {
        icon: Clock,
        title: "Hot & Fast",
        desc: "Orders prepared fresh on-call, usually ready in 25–35 minutes.",
    },
];

export const About = () => {
    return (
        <section
            id="about"
            className="relative bg-[#F5F0E6] py-16 md:py-24 overflow-hidden"
            data-testid="about-section"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                <div className="lg:col-span-5">
                    <span className="inline-block text-[11px] tracking-[0.32em] font-bold text-[#D35400] bg-white rounded-full px-3 py-1.5 border border-[#EADEC9]">
                        OUR STORY
                    </span>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black mt-4 leading-[1.05] text-[#1F1A17]">
                        Flavours worth travelling for — now a WhatsApp away.
                    </h2>
                    <p className="mt-6 text-[#7B716A] leading-relaxed">
                        Kiraak Mandi brings together the smoky soul of Arabian Mandi,
                        the fragrant romance of Hyderabadi Dum Biryani, and the royal
                        indulgence of Mughalai classics. Every plate is a story of
                        patience — grains soaked slowly, meats rested overnight, and
                        spices toasted fresh at dawn.
                    </p>
                    <div className="mt-7 flex flex-wrap gap-3">
                        <a
                            href="#menu"
                            className="btn-press inline-flex items-center gap-2 bg-[#D35400] hover:bg-[#A84300] text-white font-bold px-6 py-3 rounded-full"
                            data-testid="about-view-menu"
                        >
                            Explore the Menu
                        </a>
                        <a
                            href="#contact"
                            className="btn-press inline-flex items-center gap-2 bg-white border border-[#EADEC9] hover:border-[#D35400] text-[#1F1A17] font-bold px-6 py-3 rounded-full"
                            data-testid="about-visit-us"
                        >
                            Visit Us
                        </a>
                    </div>
                </div>

                <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
                    {FEATURES.map((f, i) => (
                        <div
                            key={i}
                            className="bg-white rounded-2xl p-6 border border-[#EADEC9] hover:-translate-y-0.5 hover:shadow-md transition-all"
                            data-testid={`feature-${i}`}
                        >
                            <div className="w-11 h-11 rounded-xl bg-[#FFF1E4] text-[#D35400] inline-flex items-center justify-center">
                                <f.icon className="w-5 h-5" />
                            </div>
                            <h3 className="font-display font-bold text-lg mt-4 text-[#1F1A17]">
                                {f.title}
                            </h3>
                            <p className="text-sm text-[#7B716A] leading-relaxed mt-1.5">
                                {f.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default About;
